import type { ActivityCalendarEntry } from '../../../../components/activities/activityDayCalendar';
import { SCHEDULING_STATUS_LABELS, type SchedulingStatus } from '../../../../components/plantafel/plantafelTypes';

export const leadHeaderEurFmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });

export function activitySchedulingStatusLabel(activity: {
  scheduling_status?: string;
  done?: boolean;
}): string {
  if (activity.done) return 'Erledigt';
  const key = (activity.scheduling_status ?? 'geplant') as SchedulingStatus;
  return SCHEDULING_STATUS_LABELS[key] ?? SCHEDULING_STATUS_LABELS.geplant;
}

/** Zeit-Eingabe zu HH:mm (24h) normalisieren */
export function normalizeTime24h(input: string): string {
  const match = input.trim().match(/^(\d{1,2}):?(\d{0,2})$/);
  if (!match) return '';
  let h = parseInt(match[1], 10);
  let m = match[2] === '' ? 0 : parseInt(match[2], 10);
  if (Number.isNaN(h)) return '';
  if (Number.isNaN(m)) m = 0;
  h = Math.max(0, Math.min(23, h));
  m = Math.max(0, Math.min(59, m));
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}

/** Dokumenttypen für „Neues Dokument erstellen“ (Lead-Detail). */
export const LEAD_DOCUMENT_TYPES = [
  'Angebot',
  'Kostenvoranschlag',
  'Auftragsbestätigung',
  'Lieferschein',
  'Rechnung',
  'Abschlagsrechnung',
  'Schlussrechnung',
  'Stornorechnung',
  'Gutschrift',
  'Arbeitsbericht',
] as const;

export function filterActivitiesForEinsatzteam(
  activities: ActivityCalendarEntry[],
  assigneeEmployeeIds: string[],
): ActivityCalendarEntry[] {
  const open = activities.filter((a) => !a.done);
  if (assigneeEmployeeIds.length === 0) return open;
  const allowed = new Set(assigneeEmployeeIds);
  return open.filter(
    (a) =>
      (a.assignee_employees ?? []).some((e) => allowed.has(e.id)) ||
      (a.primary_employee_id != null && allowed.has(a.primary_employee_id)),
  );
}
